/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { MimeTypes } from '../types/utils';

export class GenerateUploadSignedUrlInput {
	mimeTypes: Array<MimeTypes> = []
}